import styled from 'styled-components';

// Components
import { Button } from 'top-component-library';

// Constants
import breakpoints from 'constants/breakpoints';

import { Colors, Spacing } from '@doordash/design-language';

export const Container = styled.div`
  border-top: 6px solid ${Colors.BackgroundSecondary};
  padding: 1.25rem 1.25rem 0;

  @media (min-width: ${breakpoints.md}px) {
    border-top: 0;
    margin-top: 1.75rem;
    margin-left: 1.5rem;
    padding: 0;
  }
`;
export const DeleteButton = styled(Button)`
  align-items: center;
  background: var(--color-error__light);
  border: none;
  border-radius: 32px;
  display: flex;
  font-size: 0.75rem;
  letter-spacing: 1px;
  margin: 0 auto 1.5rem;
  text-transform: uppercase;

  .anticon {
    color: var(--color-error__regular);
    font-size: 1rem;
  }

  &&:focus:not([disabled]),
  &&:hover:not([disabled]) {
    background: var(--color-error__light);
    color: var(--color-error__dark);
  }

  &&:focus-visible {
    outline: 2px solid var(--color-error__dark);
  }
`;
export const Header = styled.h6`
  color: var(--bose-item__quantity-label);
  font-size: ${Spacing.Small}px;
  font-weight: 700;
  letter-spacing: 1px;
  line-height: 0.875rem;
  padding-bottom: 0.5rem;
`;
export const Qty = styled.div`
  color: var(--bose-item__quantity-count-label);
  font-size: 1.125rem;
  font-weight: bold;
  min-width: 4rem;
  padding: 0 1rem;
  text-align: center;
`;
export const Row = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin: 1.25rem 0 1.5rem;
`;
export const UpdateButton = styled(Button)`
  // Center +/- icons in this button
  .anticon {
    line-height: 0;
  }
  display: flex;
  align-items: center;
  justify-content: center;

  border: 1px solid var(--bose-item__quantity-button-outline);
  color: var(--bose-item__quantity-button-icon);
  background-color: var(--bose-item__quantity-button-background);

  &&:disabled {
    color: var(--bose-item__quantity-button-icon-disabled);
    border-color: var(--bose-item__quantity-button-outline-disabled);
    background-color: var(--bose-item__quantity-button-background-disabled);
  }

  &&:focus,
  &&:hover {
    border-color: var(--bose-item__quantity-button-outline-selected);
    color: var(--bose-item__quantity-button-icon);
    background-color: var(--bose-item__quantity-button-background);
  }
`;
